/**
 * Custom glove grouped cart handlers for Impulse theme.
 * Loaded via cart-custom-glove.liquid (mode: assets).
 */
(function () {
  'use strict';

  if (window.customGloveCartInitialized) return;
  window.customGloveCartInitialized = true;

  function rebuildCart() {
    document.dispatchEvent(new CustomEvent('cart:build'));
  }

  function collectGroupKeys(cart, assocKey) {
    var keys = [];

    if (cart.items && cart.items.length) {
      cart.items.forEach(function (item) {
        if (!item.properties) return;
        if (item.properties._AssociationKey === assocKey || item.properties._ParentKey === assocKey) {
          keys.push(item.key);
        }
      });
    }

    return keys;
  }

  function collectGroupKeysFromDom(group, keys) {
    var result = keys.slice();
    if (!group) return result;

    group.querySelectorAll('.cart__item[data-key]').forEach(function (el) {
      var key = el.dataset.key;
      if (key && result.indexOf(key) === -1) {
        result.push(key);
      }
    });

    return result;
  }

  function patchCartForm() {
    if (!window.theme || !theme.CartForm || theme.CartForm.prototype.__customGlovePatched) return;

    var proto = theme.CartForm.prototype;
    var originalInitQty = proto.initQtySelectors;
    var originalQtyChanged = proto.quantityChanged;

    proto.initQtySelectors = function () {
      var form = this.form;
      var namespace = this.namespace;
      form.querySelectorAll('.js-qty__wrapper').forEach(function (el) {
        if (el.classList.contains('cart-group-qty')) return;
        new theme.QtySelector(el, {
          namespace: namespace,
          isCart: true
        });
      });
    };

    proto.quantityChanged = function (evt) {
      var el = evt.detail && evt.detail[2];
      if (el && el.closest('.cart-group-qty')) return;
      return originalQtyChanged.call(this, evt);
    };

    proto.__customGlovePatched = true;
  }

  document.addEventListener('click', function (e) {
    var removeBtn = e.target.closest('.cart-group-remove-btn');
    if (removeBtn) {
      e.preventDefault();
      e.stopPropagation();

      var assocKey = removeBtn.dataset.assocKey;
      if (!assocKey || !window.theme || !theme.cart) return;

      removeBtn.disabled = true;
      removeBtn.textContent = 'Removing...';

      theme.cart.getCart().then(function (cart) {
        var keys = collectGroupKeysFromDom(removeBtn.closest('.cart-group'), collectGroupKeys(cart, assocKey));

        if (!keys.length) {
          removeBtn.disabled = false;
          removeBtn.textContent = 'Remove';
          rebuildCart();
          return;
        }

        return Promise.all(keys.map(function (key) {
          return theme.cart.changeItem(key, 0);
        }));
      }).then(function () {
        rebuildCart();
      }).catch(function (err) {
        console.error('Custom glove cart: remove group failed', err);
        removeBtn.disabled = false;
        removeBtn.textContent = 'Remove';
        rebuildCart();
      });

      return;
    }

    var adjustBtn = e.target.closest('.cart-group-qty .js-qty__adjust');
    if (adjustBtn) {
      e.preventDefault();
      e.stopPropagation();

      var group = adjustBtn.closest('.cart-group');
      var input = group && group.querySelector('.cart-group-qty input');
      if (!input) return;

      var qty = parseInt(input.value, 10) || 0;
      var newQty = adjustBtn.classList.contains('js-qty__adjust--plus') ? qty + 1 : Math.max(0, qty - 1);

      if (newQty === 0) {
        var groupRemove = group.querySelector('.cart-group-remove-btn');
        if (groupRemove) groupRemove.click();
      } else {
        input.value = newQty;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }

    var parentRemoveLink = e.target.closest('.cart-group .cart__item--parent a[href*="quantity=0"]');
    if (parentRemoveLink) {
      e.preventDefault();
      e.stopPropagation();
      var groupRemoveBtn = parentRemoveLink.closest('.cart-group') &&
        parentRemoveLink.closest('.cart-group').querySelector('.cart-group-remove-btn');
      if (groupRemoveBtn) groupRemoveBtn.click();
    }
  });

  document.addEventListener('change', function (e) {
    var input = e.target.closest('.cart-group-qty input');
    if (!input || !window.theme || !theme.cart) return;

    e.stopPropagation();

    var assocKey = input.dataset.assocKey;
    if (!assocKey) return;

    var qty = parseInt(input.value, 10) || 0;

    if (qty === 0) {
      var removeBtn = input.closest('.cart-group') &&
        input.closest('.cart-group').querySelector('.cart-group-remove-btn');
      if (removeBtn) removeBtn.click();
      return;
    }

    input.disabled = true;

    theme.cart.getCart().then(function (cart) {
      var keys = collectGroupKeysFromDom(input.closest('.cart-group'), collectGroupKeys(cart, assocKey));

      if (!keys.length) {
        input.disabled = false;
        rebuildCart();
        return;
      }

      return Promise.all(keys.map(function (key) {
        return theme.cart.changeItem(key, qty);
      }));
    }).then(function () {
      input.disabled = false;
      rebuildCart();
    }).catch(function (err) {
      console.error('Custom glove cart: qty update failed', err);
      input.disabled = false;
      rebuildCart();
    });
  });

  document.addEventListener('page:loaded', patchCartForm);
  if (document.readyState !== 'loading') {
    patchCartForm();
  }
})();
